var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1517,
    height: 91,
    viewBox: "0 0 1517 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 1517,
    height: 64,
    fill: "#99C8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1201,
    height: 11,
    fill: "#038B5C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6809,
    y: 11.2339,
    width: 10.5106,
    height: 23.4468,
    fill: "#02764E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6383,
    y: 34.6807,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5532,
    y: 11.2339,
    width: 10.5106,
    height: 20.2128,
    fill: "#02764E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5106,
    y: 31.4468,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 153.958,
    y: 11.2339,
    width: 10.5106,
    height: 23.4468,
    fill: "#02764E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 149.915,
    y: 34.6807,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 179.83,
    y: 11.2339,
    width: 10.5106,
    height: 20.2128,
    fill: "#02764E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 175.787,
    y: 31.4468,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 281.234,
    y: 11.2339,
    width: 10.5106,
    height: 23.4468,
    fill: "#02764E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 277.192,
    y: 34.6807,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 307.106,
    y: 11.2339,
    width: 10.5106,
    height: 20.2128,
    fill: "#02764E"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 303.064,
    y: 31.4468,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 408.51,
    y: 11.2339,
    width: 10.5106,
    height: 23.4468,
    fill: "#02764E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 404.468,
    y: 34.6807,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 434.383,
    y: 11.2339,
    width: 10.5106,
    height: 20.2128,
    fill: "#02764E"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 430.34,
    y: 31.4468,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 535.787,
    y: 11.2339,
    width: 10.5106,
    height: 23.4468,
    fill: "#02764E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 531.745,
    y: 34.6807,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 561.66,
    y: 11.2339,
    width: 10.5106,
    height: 20.2128,
    fill: "#02764E"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 557.617,
    y: 31.4468,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 663.064,
    y: 11.2339,
    width: 10.5106,
    height: 23.4468,
    fill: "#02764E"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 659.021,
    y: 34.6807,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 688.936,
    y: 11.2339,
    width: 10.5106,
    height: 20.2128,
    fill: "#02764E"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 684.894,
    y: 31.4468,
    width: 19.4043,
    height: 11.3191,
    fill: "#015035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.a22d392ad8366afd67d52c8793f6af5d.svg";
export { ForwardRef as ReactComponent };